<template>
  <div class="transparent-kendo-tab">
    <div class="page-header driver_header_mobile d-flex w-100">
      <div class="title-col d-flex w-50">
        <span class="title-icon">
          <b-icon-folder-fill></b-icon-folder-fill>
        </span>
        <span class="title-text">DEVICE MONITORING</span>
      </div>
    </div>
    <div class="page-body">
      <kendo-tabstrip class>
        <ul>
          <li
            class="k-state-active"
            @click="setSelectedTab('DEVICE_MONITORING')"
          >
            Device Monitoring
          </li>
          <!-- <li @click="setSelectedTab('NODATA')">No Data</li> -->
           <li >
            Unregistered Device
          </li> 
        </ul>
        <div class="overflow-hidden">
          <devicemonitoring />
        </div>
         <!-- <div>
          <noData />
        </div> -->
        <div>
          <unregistereddevice />
        </div>
      </kendo-tabstrip>
    </div>
  </div>
</template>
<script>
import devicemonitoring from "./DeviceMonitoring.vue";
// import noData from "./NoData.vue";
 import unregistereddevice from "./UnRegisteredDevice.vue";

export default {
  components: {
    devicemonitoring,
    // noData,
     unregistereddevice,
  },
  data() {
    return {
      selectedTab: "",
    };
  },
  methods: {
    setSelectedTab(e) {
      this.selectedTab = e;
    },
  },
};
</script>
<style lang="">
</style>